import { SxProps, useTheme } from "@mui/material"

export const useClasses = () => {
    const theme = useTheme();

    const classes = { 
        
        searchTextBox: {
            alignItems: 'center',
            width: '100%',
            height: '100%',
            justifyContent: 'center'
        } as SxProps,
    }

    return classes;
}